import { AdminInvoiceProfile } from './adminInvoiceProfile';
export class CorporateAdminProfile extends AdminInvoiceProfile {
}
//# sourceMappingURL=corporate-admin-profile.js.map